import { IconButton, InputAdornment, SxProps, TextField } from '@mui/material';
import { Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import { border, borderBox } from 'src/const';
import { searchValueActions } from 'src/context/searchValue';
import { ReactComponent as SearchIcon } from 'src/icons/search.svg';
import { ReactComponent as ClearIcon } from 'src/icons/close-sm.svg';
import useDebounce from 'src/hooks/useDebounce';
import { messagesActions } from 'src/context/messages';
import { chatsActions } from 'src/context/chats';
import { buildDataTestIdAttribute } from 'src/utils/functionHelpers';

const classes = {
  box_wrapper: {
    borderBottom: border,
    boxSizing: borderBox,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 12px 0px 12px',
    height: '92px',
  } as SxProps,
};

const styles = {
  width: '406px',
  '& .MuiInputBase-root': {
    gap: '0',
    height: '42px',
  },
};

type SearchBlockConversationProps = {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  dataTestId?: string;
};

export const SearchBlockConversation: React.FC<SearchBlockConversationProps> = ({
  searchValue,
  setSearchValue,
  dataTestId,
}) => {
  const debouncedValue = useDebounce<string>(searchValue, 300);

  const [isFocused, setIsFocused] = useState(false);

  const onBlurInput = () => {
    setIsFocused(false);
  };

  const onFocusInput = () => {
    setIsFocused(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value);

  const handleClearClick = () => {
    setSearchValue('');
  };

  useEffect(() => {
    if (debouncedValue.length === 0 || debouncedValue.length > 2) {
      searchValueActions?.setSearchValueConversation(debouncedValue);
    }
  }, [debouncedValue]);
  return (
    <Stack
      sx={{
        ...classes.box_wrapper,
        borderBottom: 'unset',
      }}
    >
      <TextField
        variant="outlined"
        placeholder="Search"
        sx={styles}
        value={searchValue}
        onBlur={onBlurInput}
        onFocus={onFocusInput}
        onChange={handleChange}
        onClick={() => {
          messagesActions.setIsViewFoundMessagesConversation(true);
          chatsActions.setAnchorMessage('');
        }}
        {...buildDataTestIdAttribute(dataTestId, 'input-search-messages')}
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              sx={{
                margin: '0 8px 0 0',
              }}
            >
              <Stack direction="row" gap="4px" flexWrap="nowrap" alignItems="center">
                <SearchIcon />
              </Stack>
            </InputAdornment>
          ),
          endAdornment: (
            <IconButton
              sx={{ visibility: searchValue && isFocused ? 'visible' : 'hidden', padding: '0', height: '100%' }}
              onMouseDown={handleClearClick}
            >
              <ClearIcon />
            </IconButton>
          ),
          ...buildDataTestIdAttribute(dataTestId, 'button-clear'),
        }}
      />
    </Stack>
  );
};
